var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFeatureFlash = function SvgFeatureFlash(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82133 0.905893C9.24266 0.400559 10.0633 0.745893 9.99666 1.40056L9.52599 5.99923H13.3333C13.46 5.99927 13.584 6.03541 13.6909 6.10341C13.7978 6.1714 13.8831 6.26844 13.9368 6.38316C13.9905 6.49788 14.0105 6.62554 13.9943 6.75117C13.9781 6.87681 13.9264 6.99522 13.8453 7.09256L7.17866 15.0926C6.75733 15.5979 5.93666 15.2526 6.00333 14.5979L6.47399 9.99923H2.66666C2.53999 9.99918 2.41594 9.96304 2.30906 9.89504C2.20218 9.82705 2.11689 9.73001 2.06317 9.61529C2.00944 9.50057 1.98952 9.37292 2.00572 9.24728C2.02193 9.12165 2.07359 9.00323 2.15466 8.90589L8.82133 0.905893ZM4.08999 8.66589H7.65533C7.6926 8.66589 7.72945 8.6737 7.76351 8.68882C7.79758 8.70394 7.82809 8.72603 7.8531 8.75367C7.8781 8.78131 7.89703 8.81388 7.90866 8.84929C7.9203 8.88469 7.92439 8.92214 7.92066 8.95923L7.55199 12.5626L11.91 7.33256H8.34466C8.30739 7.33256 8.27054 7.32475 8.23647 7.30963C8.20241 7.29451 8.17189 7.27242 8.14689 7.24478C8.12189 7.21714 8.10296 7.18457 8.09133 7.14916C8.07969 7.11376 8.0756 7.07631 8.07933 7.03923L8.44799 3.43656L4.08999 8.66589Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82133 0.905893C9.24266 0.400559 10.0633 0.745893 9.99666 1.40056L9.52599 5.99923H13.3333C13.46 5.99927 13.584 6.03541 13.6909 6.10341C13.7978 6.1714 13.8831 6.26844 13.9368 6.38316C13.9905 6.49788 14.0105 6.62554 13.9943 6.75117C13.9781 6.87681 13.9264 6.99522 13.8453 7.09256L7.17866 15.0926C6.75733 15.5979 5.93666 15.2526 6.00333 14.5979L6.47399 9.99923H2.66666C2.53999 9.99918 2.41594 9.96304 2.30906 9.89504C2.20218 9.82705 2.11689 9.73001 2.06317 9.61529C2.00944 9.50057 1.98952 9.37292 2.00572 9.24728C2.02193 9.12165 2.07359 9.00323 2.15466 8.90589L8.82133 0.905893ZM4.08999 8.66589H7.65533C7.6926 8.66589 7.72945 8.6737 7.76351 8.68882C7.79758 8.70394 7.82809 8.72603 7.8531 8.75367C7.8781 8.78131 7.89703 8.81388 7.90866 8.84929C7.9203 8.88469 7.92439 8.92214 7.92066 8.95923L7.55199 12.5626L11.91 7.33256H8.34466C8.30739 7.33256 8.27054 7.32475 8.23647 7.30963C8.20241 7.29451 8.17189 7.27242 8.14689 7.24478C8.12189 7.21714 8.10296 7.18457 8.09133 7.14916C8.07969 7.11376 8.0756 7.07631 8.07933 7.03923L8.44799 3.43656L4.08999 8.66589Z",
    fill: "url(#paint0_linear_0_7)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_7",
    x1: 2.00024,
    y1: 7.99923,
    x2: 13.9997,
    y2: 7.99923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6E64"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFeatureFlash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/feature-flash.dec3764a677b6275e1e2742be6190ddf.svg";